import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight, Clock3 } from "lucide-react";
import { LOCATIONS } from "@/constants/content";

export default function AreasWeServe() {
  return (
    <section className="section bg-white" data-testid="areas-section">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="eyebrow mb-3">Areas We Serve</div>
            <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
              Home healthcare across <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">Delhi NCR</span>.
            </h2>
            <p className="mt-4 text-slate-600">Our verified staff is stationed across all six cities for rapid, same-day response.</p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {LOCATIONS.map((l, i) => (
            <motion.div
              key={l.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.35, delay: (i % 3) * 0.07 }}
            >
              <Link
                to={`/locations/${l.slug}`}
                className="group block rounded-2xl overflow-hidden bg-white border border-slate-200/70 hover:border-[#0A84FF]/30 hover:shadow-xl transition-all"
                data-testid={`area-${l.slug}`}
              >
                <div className="relative h-40 overflow-hidden bg-gradient-to-br from-[#0A84FF]/10 to-[#10B981]/10">
                  <img src={l.image} alt={l.name} className="w-full h-full object-cover mix-blend-multiply opacity-90 group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/20 to-transparent" />
                  <div className="absolute bottom-3 left-4 text-white">
                    <div className="flex items-center gap-1.5 text-[11px] font-medium text-white/85">
                      <Clock3 className="h-3 w-3" /> {l.responseTime}
                    </div>
                    <div className="font-display font-bold text-xl mt-0.5">{l.name}</div>
                  </div>
                </div>
                <div className="p-4 flex items-start justify-between gap-3">
                  <div className="text-xs text-slate-600 leading-relaxed line-clamp-2">
                    <MapPin className="inline h-3 w-3 mr-1 -mt-0.5" style={{ color: '#0A84FF' }} />
                    {l.coverage}
                  </div>
                  <ArrowUpRight className="h-4 w-4 text-slate-400 group-hover:text-[#0A84FF] shrink-0" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
